import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import numeral from 'numeral';
import { PESO_SYMBOL } from '../../helpers/constants/app';
import ViewportSizeMixin from '../../helpers/mixins/ViewportSizeMixin';
let SalesOverviewItem = class SalesOverviewItem extends Mixins(ViewportSizeMixin) {
    get proButtonStyle() {
        if (this.headerTitle === 'Viber') {
            return { '-activated': true };
        }
        return { '-activated': this.activated };
    }
    get proText() {
        if (this.headerTitle === 'Viber') {
            return 'Activate';
        }
        return !this.activated ? 'Available on Starter Plan' : 'Activate';
    }
    routeToSalesChannel() {
        if (this.activated || this.headerTitle === 'Viber') {
            this.$router.push({ name: this.proSettingRoute });
        }
        else {
            this.$router.push({ name: 'enterprise-plans' });
        }
    }
    numeralizedAmount(value, currency = PESO_SYMBOL) {
        const numValue = numeral(+value);
        const format = value > 9999 ? '0a' : '0,0';
        return `${currency}${numValue.format(format)}`;
    }
    get uniqueOrdersStyle() {
        // only for approximation
        if (this.$vuetify.breakpoint.width > 1742) {
            return 'margin-left: 70%;';
        }
        return '';
    }
};
__decorate([
    Prop({ type: String, default: '' })
], SalesOverviewItem.prototype, "headerTitle", void 0);
__decorate([
    Prop({ type: Number, default: 0 })
], SalesOverviewItem.prototype, "amount", void 0);
__decorate([
    Prop({ type: Number, default: 0 })
], SalesOverviewItem.prototype, "value", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], SalesOverviewItem.prototype, "isSalesChannel", void 0);
__decorate([
    Prop({ type: String, default: null })
], SalesOverviewItem.prototype, "img", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], SalesOverviewItem.prototype, "isPro", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], SalesOverviewItem.prototype, "loading", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], SalesOverviewItem.prototype, "activated", void 0);
__decorate([
    Prop({ type: String, default: '' })
], SalesOverviewItem.prototype, "proSettingRoute", void 0);
__decorate([
    Prop({ type: String, default: null })
], SalesOverviewItem.prototype, "salesChannelIcon", void 0);
SalesOverviewItem = __decorate([
    Component
], SalesOverviewItem);
export default SalesOverviewItem;
